<div class="d-flex justify-content-between align-items-center mb-2">
  <div class="d-flex align-items-center">
    <div class="fw-bold">{{ data.title }}</div>
  </div>
  <div class="justify-content-end">
    <span
      *ngIf="selectedImages.length > 0"
      class="danger-text enablePointer"
      (click)="removeImages()"
    >
      Remove
    </span>
  </div>
</div>
<div
  #dropListContainer
  class="grid-custom position-relative w-100"
  style="--grid-col-size: 6; --grid-col-size-sm: 4; --grid-gap: 0.3rem"
  cdkDropListGroup
  (dragover)="onDragEnter($event)"
>
  <ng-container
    *ngFor="let image of mediaData; let first = first; let i = index"
  >
    <div
      [class.first-item]="first"
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListData]="{ item: image, index: i }"
      (cdkDropListDropped)="drope($event)"
      (cdkDropListEntered)="dragEntered($event, i)"
    >
      <div
        class="border outline-variant rounded-3 d-flex align-items-center justify-content-center w-100 h-100 overflow-hidden position-relative curser-pointer image-hover"
        style="aspect-ratio: 1 / 1"
        cdkDrag
        [cdkDragData]="{ index: i, item: image }"
        (cdkDragStarted)="dragStart($event, i)"
        (cdkDragMoved)="dragMoved($event)"
        #draggedItem
      >
        <div class="media-custom-placeholder" *cdkDragPlaceholder></div>
        <div
          *ngIf="image.status"
          class="position-absolute end-0 start-0 top-0 bottom-0 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center"
        >
          <div role="status" class="spinner-border">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <label
          class="position-absolute top-0 bottom-0 end-0 start-0 bg-dark bg-opacity-75 rounded-3 m-0"
          style="z-index: 1000"
          id="hide"
          [for]="data.id + i"
          [class.d-block]="selectedImages.indexOf(image.id) !== -1"
          *ngIf="!image.status"
        >
          <div class="d-flex align-items-center justify-content-between p-2">
            <button
              type="button"
              class="btn btn-light position-relative p-0 avatar-xs rounded-circle"
              (click)="openMediaPlayer(image, i)"
            >
              <span class="avatar-title bg-transparent text-reset">
                <i class="bx bx-fullscreen"></i>
              </span>
            </button>
            <input
              class="form-check-input m-0"
              type="checkbox"
              [id]="data.id + i"
              (change)="selectedImges($event, image.id)"
              [disabled]="isDisabled"
            />
          </div>
        </label>
        <ng-container
          *ngIf="
            isImageUrl(image.url) ||
            data.media_type == 'image' ||
            data.media_type == 'gif'
          "
        >
          <img
            [src]="image.url"
            alt=""
            class="rounded-2 img-fluid h-100 object-fit-contain"
          />
        </ng-container>
        <ng-container *ngIf="isVideoUrl(image.url)">
          <video
            [src]="image.url"
            class="rounded-2 object-fit-contain"
            style="max-width: 100%; max-height: 100%"
          ></video>
        </ng-container>
        <ng-container *ngIf="isAudioUrl(image.url)">
          <audio controls>
            <source [src]="image.url" />
            Your browser does not support the audio element.
          </audio>
        </ng-container>
        <ng-template cdkDragPreview>
          <div
            class="drag-preview d-flex align-items-center justify-content-center"
            [ngStyle]="dragPreviewStyle"
          >
            <ng-container *ngIf="isImageUrl(image.url)">
              <img
                [src]="image.url"
                alt=""
                class="img-fluid object-fit-contain"
              />
            </ng-container>
            <ng-container *ngIf="isVideoUrl(image.url)">
              <video
                [src]="image.url"
                class="rounded-2 object-fit-contain"
                style="max-width: 100%; max-height: 100%"
              ></video>
            </ng-container>
            <ng-container *ngIf="isAudioUrl(image.url)">
              <audio controls>
                <source [src]="image.url" />
                Your browser does not support the audio element.
              </audio>
            </ng-container>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <div
    class="rounded-3 align-items-center justify-content-center"
    [ngClass]="{
      'd-flex': data.max > mediaData.length || data.max == -1,
      'd-none': !(data.max > mediaData.length) && data.max != -1,
      'all-width': mediaData.length == 0,
      'aspect-custom': mediaData.length != 0,
    }"
  >
    <!-- <div class="row m-0"> -->
    <div
      [ngClass]="mediaData.length === 0 ? 'd-flex' : 'd-none'"
      class="dropzone-pro rounded-3 w-100 d-flex align-items-center justify-content-center"
      style="height: 150px"
      #mainDR
      [dropzone]="dropzoneConfig"
      (addedFiles)="filesAdd($event)"
      (success)="onSuccess($event)"
      (error)="onError($event)"
    >
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center justify-content-center mb-2">
          <button
            *ngIf="data?.mode?.includes('upload')"
            type="button"
            class="custm-btn me-3"
            #mainBt
            [dropzone]="dropzoneConfig"
            (addedFiles)="filesAdd($event)"
            (success)="onSuccess($event)"
            (error)="onError($event)"
          >
            Upload New
          </button>
          <a
            *ngIf="data?.mode?.includes('gallery')"
            class="link-dark custum-link me-3"
            (click)="largeModal(imageUploader)"
          >
            Select existing
          </a>
          <div
            *ngIf="data?.mode?.includes('url')"
            class="dropdown"
            dropdown
            [insideClick]="true"
          >
            <!-- <md-text-button dropdownToggle type="button">Add from URL <span class="caret"></span></md-text-button> -->
            <a dropdownToggle class="link-dark custum-link"
              >Add from URL <span class="caret"></span
            ></a>
            <!-- <button dropdownToggle type="button" class="btn btn-link btn-rounded">
            Add from URL
            </button> -->
            <ul
              *dropdownMenu
              class="dropdown-menu p-3 rounded-3"
              role="menu"
              aria-labelledby="dropdownMenuButton"
              style="width: 320px"
            >
              <form [formGroup]="urlForm" (ngSubmit)="addImageUrl()">
                <li class="mb-2">
                  <label class="form-label mb-1">
                    Image, YouTube, or Vimeo URL
                  </label>

                  <input
                    type="text"
                    class="form-control input-rounded input-focus-border rounded-form"
                    id="title"
                    formControlName="imageUrl"
                    placeholder="https://"
                    [ngClass]="{
                      'is-invalid': submitted && f.imageUrl.errors,
                    }"
                  />
                  <div
                    *ngIf="submitted && f.imageUrl.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f.imageUrl.errors.required">URL required</div>
                    <div *ngIf="f.imageUrl.errors.pattern">invalied URL</div>
                  </div>
                </li>
                <li>
                  <button class="btn btn-secondary btn-sm" type="submit">
                    Add file
                  </button>
                </li>
              </form>
            </ul>
          </div>
        </div>

        <span class="text-muted">Accepts {{ data.media_type }}</span>
      </div>
    </div>
    <!-- </div> -->
    <div
      *ngIf="
        mediaData.length > 0 &&
        (mediaData.length === -1 ||
          mediaData.length < data.max ||
          data.max == -1)
      "
      class="dropzone-pro rounded-3 w-100 h-100 d-flex align-items-center justify-content-center"
      (click)="largeModal(imageUploader)"
    >
      <ng-container>
        <i class="bx bx-plus font-size-24"></i>
      </ng-container>
    </div>
  </div>
  <div
    class="position-absolute top-0 start-0 end-0 bottom-0 bg-light z-0"
    [ngStyle]="{ display: !toggleDropZone ? 'none' : 'block' }"
    (dragleave)="onDragLeave($event)"
  >
    <div
      class="rounded-3 h-100 d-flex align-items-center justify-content-center"
    >
      <div
        class="dropzone-pro w-100 h-100 d-flex align-items-center justify-content-center rounded-3"
        #main
        [dropzone]="dropzoneConfig"
        (drop)="onDragLeave($event)"
        (addedFiles)="filesAdd($event)"
        (success)="onSuccess($event)"
        (error)="onError($event)"
      >
        Drop Media To Upload
      </div>
    </div>
  </div>
</div>

<ng-template #imageUploader let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Select Media</h5>
    <button
      type="button"
      class="btn-close"
      aria-hidden="true"
      (click)="modalRef?.hide()"
    ></button>
  </div>
  <div class="modal-body p-0" style="height: 80vh">
    <app-media-center
      [data]="data"
      (images)="selectSlotImage($event)"
      (cancel)="modalRef?.hide()"
    ></app-media-center>
  </div>
</ng-template>
